var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9375 12.25C3.9375 11.5251 4.52513 10.9375 5.25 10.9375H36.75C37.4749 10.9375 38.0625 11.5251 38.0625 12.25C38.0625 12.9749 37.4749 13.5625 36.75 13.5625H5.25C4.52513 13.5625 3.9375 12.9749 3.9375 12.25Z",
    fill: "#2A374E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9375 21C3.9375 20.2751 4.52513 19.6875 5.25 19.6875H36.75C37.4749 19.6875 38.0625 20.2751 38.0625 21C38.0625 21.7249 37.4749 22.3125 36.75 22.3125H5.25C4.52513 22.3125 3.9375 21.7249 3.9375 21Z",
    fill: "#2A374E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9375 29.75C3.9375 29.0251 4.52513 28.4375 5.25 28.4375H36.75C37.4749 28.4375 38.0625 29.0251 38.0625 29.75C38.0625 30.4749 37.4749 31.0625 36.75 31.0625H5.25C4.52513 31.0625 3.9375 30.4749 3.9375 29.75Z",
    fill: "#2A374E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burger-menu.82b863a3891a6db7d5b7687395c21852.svg";
export { ForwardRef as ReactComponent };